/** biome-ignore-all lint/suspicious/noArrayIndexKey: Because embla-carousel-react uses index as key */
'use client';

import useEmblaCarousel from 'embla-carousel-react';
import type { ReactNode } from 'react';
import './style.css';

type InfiniteCarouselProps = {
  slideWidthPercentage: number;
  slideWidthPercentageMobile?: number;
  children: ReactNode[];
};

import { cn } from '@/utils/cn';

import { DotButton, useDotButton } from './dot';

export const InfiniteCarousel = ({
  slideWidthPercentage,
  slideWidthPercentageMobile,
  children,
}: InfiniteCarouselProps) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    loop: true,
    slidesToScroll: 'auto',
    dragFree: true,
  });

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  return (
    <section
      className="embla"
      style={
        {
          '--slide-size': `${slideWidthPercentage}%`,
          '--slide-size-mobile': `${slideWidthPercentageMobile}%`,
        } as React.CSSProperties
      }
    >
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {children.map((child, index) => (
            <div className="embla__slide" key={index}>
              {child}
            </div>
          ))}
        </div>
      </div>

      {scrollSnaps.length > 1 && (
        <div className="embla__controls">
          <div className="embla__dots">
            {scrollSnaps.map((snap, index) => (
              <DotButton
                className={cn(
                  'embla__dot',
                  selectedIndex === index && 'embla__dot--selected'
                )}
                key={snap}
                onClick={() => onDotButtonClick(index)}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
